import { render, staticRenderFns } from "./smsWhitelist.vue?vue&type=template&id=5b3c12a2&scoped=true"
import script from "./smsWhitelist.vue?vue&type=script&lang=js"
export * from "./smsWhitelist.vue?vue&type=script&lang=js"
import style0 from "./smsWhitelist.vue?vue&type=style&index=0&id=5b3c12a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3c12a2",
  null
  
)

export default component.exports